<template>
  <r-panel :disabled="disabled" :title="title" :empty="items.length === 0" :button_add="true" @click_add="click_add">
    <r-reward-package-table ref="table" :items.sync="values" :toolbar="false"/>
  </r-panel>
</template>

<script>
import VueTypes from "vue-types";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RRewardPackageTable from "@/modules/redactor/views/reward-pack/r-reward-package-table.vue";

export default {
  name: "r-reward-package-panel",
  components: {RRewardPackageTable, RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Packages"),
    items: VueTypes.arrayOf(VueTypes.string) //CardModel_UID
  },
  computed: {
    values() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>